import { useEffect, useRef, useState } from "react";
import { apiFetch } from "../api";
import { BASE_URL as u } from "../../commonUrls";
import "./AIChatWidget.css";

export default function AIChatWidget() {
  const [open, setOpen] = useState(false);
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const bottomRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    bottomRef.current?.scrollIntoView({ behavior: "smooth", block: "end" });
  }, [messages, loading, open]);

  const send = async () => {
    const prompt = input.trim();
    if (!prompt || loading) return;

    setMessages((prev) => [...prev, { sender: "user", text: prompt }]);
    setInput("");
    setLoading(true);

    try {
      const response = await apiFetch(`${u}/generate-text?provider=OPENAI`, {
        method: "POST",
        body: JSON.stringify(prompt),
      });
      if (!response.ok) {
        throw new Error("AI request failed");
      }
      const text = await response.text();
      setMessages((prev) => [...prev, { sender: "ai", text }]);
    } catch {
      setMessages((prev) => [...prev, { sender: "ai", text: "Could not reach AI service." }]);
    } finally {
      setLoading(false);
    }
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      send();
    }
  };

  return (
    <div className="ai-widget-root">
      {open && (
        <div className="ai-widget-panel" role="dialog" aria-label="AI Chat">
          <div className="ai-widget-head">
            <strong>AI Chat</strong>
            <button
              type="button"
              className="ai-widget-close"
              onClick={() => setOpen(false)}
              aria-label="Close AI chat"
            >
              x
            </button>
          </div>

          <div className="ai-widget-body">
            {messages.length === 0 ? (
              <div className="ai-widget-empty">Ask anything. I can help right here.</div>
            ) : (
              messages.map((m, i) => (
                <div
                  key={`${m.sender}-${i}`}
                  className={m.sender === "user" ? "ai-widget-msg-user" : "ai-widget-msg-ai"}
                >
                  {m.text}
                </div>
              ))
            )}
            {loading && <div className="ai-widget-empty">Thinking...</div>}
            <div ref={bottomRef} />
          </div>

          <div className="ai-widget-input-wrap">
            <textarea
              rows={2}
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={onKeyDown}
              className="ai-widget-input"
              placeholder="Type your question..."
            />
            <button type="button" className="ai-widget-send" onClick={send} disabled={loading}>
              {loading ? "..." : "Send"}
            </button>
          </div>
        </div>
      )}

      <button
        type="button"
        className="ai-widget-fab"
        onClick={() => setOpen((v) => !v)}
        aria-label="Open AI chat"
      >
        AI
      </button>
    </div>
  );
}
